import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}
export function PageHero({
  title,
  subtitle,
  backgroundImage
}: PageHeroProps) {
  return <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 bg-brand-dark overflow-hidden flex items-center justify-center min-h-[50vh]" data-id="element-251">
      {/* Background Image */}
      {backgroundImage && <div className="absolute inset-0 z-0" data-id="element-252">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover opacity-30" data-id="element-253" />
          <div className="absolute inset-0 bg-brand-dark/70" data-id="element-254"></div>
        </div>}

      {/* Noise Overlay */}
      <div className="absolute inset-0 bg-noise pointer-events-none z-20 opacity-50" data-id="element-255"></div>

      {/* Subtle background gradient */}
      {!backgroundImage && <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-red/20 via-transparent to-transparent z-[1]" data-id="element-256"></div>}

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto" data-id="element-257">
        <motion.h1 className="text-5xl md:text-7xl font-serif text-white mb-6" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-258">
          {title}
        </motion.h1>

        {subtitle && <motion.p className="text-lg md:text-xl text-white/70 font-light max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-259">
            {subtitle}
          </motion.p>}

        <motion.div className="w-24 h-1 bg-brand-gold mx-auto mt-10" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeInOut'
      }} data-id="element-260" />
      </div>
    </section>;
}